import React from 'react';
import Header from '../Header';
import Searchbox from '../SearchBox';
import HeadLine from '../HeadLine';
import HeroImage from '../HeroImage';
import Jumbotron from '../Jumbotron';
import { Experiment } from '../Experiment';

const HeroContent = () => (
  <header role="banner">
    <Header />
    <Experiment name={'HA_PTA_LANDING_LocalizedHPHeroImage'} earlyReport >
      <HeroImage>
        <Jumbotron>
          <HeadLine />
          <Searchbox />
        </Jumbotron>
      </HeroImage>
    </Experiment>
  </header>
);

export default HeroContent;
